// Reads every page of a paged list endpoint.
//
// For the handful of reads that need a member's *whole* set rather than a screenful -- a picker, a
// total, a rule applied across all rows -- where asking for one enormous page instead makes the
// server materialise it in one go and silently truncates anyway if the cap is ever lowered.
//
// `fetchPage({ page, elementPerPage })` resolves to `{ items, totalCount }`. It owns its own
// validation: anything it throws ends the walk and reaches the caller untouched.

export const DEFAULT_PAGE_SIZE = 100;

// A server that ignores paging would otherwise be walked for ever. At the default size this is
// 5,000 rows, far past any real membership history.
export const DEFAULT_PAGE_LIMIT = 50;

export const fetchAllPages = async (fetchPage, options = {}) => {
  const elementPerPage = options.elementPerPage || DEFAULT_PAGE_SIZE;
  const pageLimit = options.pageLimit || DEFAULT_PAGE_LIMIT;

  const collected = [];

  for (let page = 1; page <= pageLimit; page += 1) {
    // Sequential by nature: whether there is a next page is only known once this one is back.
    // eslint-disable-next-line no-await-in-loop
    const { items, totalCount } = await fetchPage({ page, elementPerPage });
    const batch = items || [];

    collected.push(...batch);

    // A short page is the last page. Checked before the count so a server that reports no total,
    // or a wrong one, still terminates.
    if (batch.length < elementPerPage) break;
    if (Number.isFinite(totalCount) && collected.length >= totalCount) break;
  }

  return collected;
};

export default fetchAllPages;
